/** Normalises raw OTC input to XXXX-XXXX display format.
 * Strips non-alphanumeric characters, uppercases, takes first 8 characters, and inserts a hyphen after position 4. */
export const formatOneTimeCode = (rawInput: string): string => {
  const stripped = rawInput.replace(/[^A-Za-z0-9]/g, '').toUpperCase().slice(0, 8);
  if (stripped.length > 4) {
    return `${stripped.slice(0, 4)}-${stripped.slice(4)}`;
  }
  return stripped;
};
